import { motion } from "framer-motion";
import { FaArrowDown } from "react-icons/fa";
import styled from "styled-components";
import { useTheme } from "styled-components";
const ScrollArrow = styled(motion.div)`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: white;
  position: relative;
  transition: background-color 0.2s ease-in-out; /* Suaviza la transición */

  &:hover {
    background-color:  ${({theme}) => theme.colors.secondary};
  }

`;

const ArrowButton = ({ targetId }) => {
  const scrollToSection = () => {
    document.getElementById(targetId)?.scrollIntoView({ behavior: "smooth" });
  };
  const theme = useTheme();
  return (
    <ScrollArrow
      onClick={scrollToSection}
      animate={{ y: [0, 10, 0] }} // Hace que la flecha suba y baje suavemente
      transition={{ duration: 1.2, repeat: Infinity }}
    >
      <FaArrowDown size="2rem" color="#000" />
    </ScrollArrow>
  );
};

export default ArrowButton;